import { Home as HomeComponent } from '@/components/pages/Home';

const HomePage = () => {
  return <HomeComponent />;
};

export default HomePage;
